import React from 'react';
import {
  Container,
  Content,
  HeaderBox,
  Image,
  Item,
  MessageText,
  SubContainer,
  TitleText,
} from './styled';

import { AptunoButton, SIZES, VARIANTS } from '@aptuno/aptuno-ui';
import { useRouter } from 'next/router';

export type ModalLeaveProps = {
  isPublish?: boolean;
  onClose: () => void;
};

function ModalLeave(props: ModalLeaveProps) {
  const { isPublish, onClose } = props;
  const router = useRouter();
  return (
    <Container>
      <HeaderBox />
      <SubContainer>
        <Image
          src="/images/PublishLeave.svg"
          alt="leave"
          title="Imagen de Cancelar Proceso | Aptuno"
        />
        <Content>
          <TitleText>
            Vas a abandonar tu {isPublish ? 'publicación.' : 'agendamiento'}
          </TitleText>
          {isPublish && (
            <MessageText>
              Guardaremos la información que has ingresado hasta el momento.
              ¿Pero estás seguro?
            </MessageText>
          )}
          <Item>
            <AptunoButton
              onClick={() => router.push('/')}
              appearance={VARIANTS.DANGER}
              size={SIZES.BIG}
            >
              Sí, abandonar.
            </AptunoButton>
          </Item>
          <Item>
            <AptunoButton
              onClick={onClose}
              appearance={VARIANTS.SECONDARY}
              size={SIZES.BIG}
            >
              No, volver {isPublish ? 'a la publicación.' : 'al agendamiento.'}
            </AptunoButton>
          </Item>
        </Content>
      </SubContainer>
    </Container>
  );
}

export { ModalLeave, ModalLeave as default };
